// extracted by mini-css-extract-plugin
export default {"desktop":"Fld3l4","compact":"zs8RNb","mobile":"gwdCwU","upgrade":"Q0GE08"};